import { ICON__upload } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import { PLACEHOLDER_BUTTON__bar } from '@/pages/_base/buttons/PLACEHOLDER_BUTTON__bar';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list } from '@/utils/_methods/FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list';
import { upload_images_multiple } from '@/utils/utils_upload';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { FIELD__list_image_asset } from '@shared/dto/generation/graph_invoke/_fields/_primitives/list/FIELD__list_image_asset';
import { ENUM__image_asset_category } from '@shared/dto/generation/graph_invoke/_fields/ENUM__image_asset_category';
import { useTranslation } from 'react-i18next';

interface PROPS {
  field: FIELD__list_image_asset;
}

export function G_GRAPH__BUTTON__list_images_upload({ field }: PROPS) {
  const { t: t_base_ui } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  /*
   * STORE
   */
  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  const { toast } = useToast();

  /*
   * STATE
   */

  /*
   * EVENTS
   */
  function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    if (field.items.length >= CONSTANTS__shared.IP_ADAPTER_IMAGES_LIMIT) return;

    let images_limit = CONSTANTS__shared.IP_ADAPTER_IMAGES_LIMIT - field.items.length;

    upload_images_multiple(
      toast,
      file_data_list => FN_IMAGE_FILE_DATA__upload_to_workspace_and_set_to_graph_list(file_data_list, field),
      t_base_ui,
      images_limit,
    );
  }

  /*
   * METHODS
   */
  function is_disabled(): boolean {
    return g_general__ui_disabled;
  }

  /*
   * HTML
   */

  if (!field.is_ready_for_manual_edit()) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;
  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE))
    return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;
  if (field.category != ENUM__image_asset_category.IMAGE) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;
  if (field.items.length >= CONSTANTS__shared.IP_ADAPTER_IMAGES_LIMIT) return <PLACEHOLDER_BUTTON__bar class_name_button="size-6" />;

  return (
    <UI_PRIMITIVE__button disabled={is_disabled()} size={'square-6'} variant={'no-border-on-bar'} {...{ onClick }}>
      <ICON__upload className="!size-3" />
    </UI_PRIMITIVE__button>
  );
}
